export enum RolesUsersEnum {
  ADMIN = "ADMINISTRADOR",
  MANAGER = "BUSINESS BANKER",
  CORBAN = "CORBAN",
  PARTNER = "PARTNER"
}

export enum RolesLabelEnum {
  ADMIN = "ADMINISTRADOR",
  "BUSINESS BANKER" = "BANKER+",
  CORBAN = "GESTOR MASTER",
  PARTNER = "PARTNER"
}

export enum RolesUsersModalEnum {
  ALL = "ALL",
  MANAGER = "BUSINESS BANKER",
  CORBAN = "CORBAN",
}

export enum RolesLabelModalLeadsEnum {
  ALL = "Todos",
  "BUSINESS BANKER" = "Banker+",
  CORBAN = "Correspondente",
}
